export const fr = {
  nav: {
    listings: "Annonces",
    map: "Carte",
    favorites: "Favoris",
    messages: "Messages",
    publish: "Publier",
    login: "Connexion",
    register: "Créer un compte",
    dashboard: "Tableau de bord",
    logout: "Déconnexion",
    tagline: "Sans Frontières",
    subtitle: "Marché Immobilier Maghreb",
  },
  home: {
    badge: "Sans Frontières · Maghreb",
    title_part1: "Le plus grand",
    title_part2: "marché immobilier",
    title_part3: "du",
    title_highlight: "Maghreb",
    description: "Annonces vérifiées de particuliers et d'agences professionnelles au Maroc, en Algérie et en Tunisie. Recherche puissante, carte interactive et contact direct.",
    cta_browse: "Parcourir les annonces",
    cta_publish: "Publier une annonce",
    stat_listings: "Annonces actives",
    stat_advertisers: "Annonceurs",
    stat_verified: "Pros vérifiés",
    stat_countries: "Maghreb",
    featured_overline: "Sélection",
    featured_title: "Annonces à la une",
    country_all: "Tous",
    view_all: "Voir toutes les annonces",
    pros_overline: "Pour les agences",
    pros_title: "Boostez votre visibilité auprès de milliers d'acheteurs.",
    pros_desc: "Badge \"Pro vérifié\", boost d'annonces, statistiques détaillées, gestion centralisée. La plateforme dédiée aux professionnels de l'immobilier maghrébin.",
    pros_cta: "Créer un compte Pro",
  },
  search: {
    overline: "Recherche",
    title: "Annonces immobilières",
    placeholder_country: "Pays",
    placeholder_type: "Vente / Location",
    placeholder_property_type: "Type de bien",
    placeholder_city: "Ville",
    placeholder_min_price: "Prix min",
    placeholder_max_price: "Prix max",
    placeholder_keyword: "Mot-clé (ex: piscine, vue mer...)",
    placeholder_rooms: "Pièces min",
    button_reset: "Réinit.",
    button_search: "Rechercher",
    grid: "Grille",
    map: "Carte",
    results_count_one: "{{count}} annonce trouvée",
    results_count_other: "{{count}} annonces trouvées",
    no_results: "Aucune annonce ne correspond à vos critères.",
    countries: { all_long: "Tous les pays", all_short: "Tous", MA: "Maroc", DZ: "Algérie", TN: "Tunisie" },
    types: { all: "Vente & Location", vente: "Vente", location: "Location" },
  },
  detail: {
    back: "Retour aux résultats",
    description: "Description",
    amenities: "Équipements",
    location: "Localisation",
    send_message: "Envoyer le message",
    sending: "Envoi...",
    add_to_favorites: "Ajouter aux favoris",
    in_favorites: "Dans vos favoris",
    badge_verified: "Annonce vérifiée",
    verified_text: "Tous nos annonceurs Pro sont vérifiés manuellement pour garantir des transactions sereines.",
  },
  auth: {
    login_title: "Bon retour parmi nous",
    login_subtitle: "Accédez à votre tableau de bord 3aqarate.",
    register_title: "Rejoignez 3aqarate",
    register_subtitle: "Publiez vos annonces en quelques minutes.",
    email: "Email",
    password: "Mot de passe",
    name: "Nom complet",
    role: "Type de compte",
    role_particulier: "Particulier",
    role_pro: "Professionnel / Agence",
    company: "Nom de l'agence",
    country: "Pays",
    submit_login: "Se connecter",
    submit_register: "Créer mon compte",
    or: "ou",
    google_continue: "Continuer avec Google",
    google_signup: "S'inscrire avec Google",
    no_account: "Pas encore de compte ?",
    yes_account: "Déjà inscrit ?",
    create: "Créer un compte",
  },
  dashboard: {
    overline: "Tableau de bord",
    greeting: "Bonjour, {{name}}",
    pro: "Pro vérifié",
    particulier: "Compte particulier",
    new_listing: "Nouvelle annonce",
    stats_total: "Annonces",
    stats_active: "Actives",
    stats_boosted: "Boostées",
    stats_favorites: "Favoris reçus",
    stats_messages: "Messages",
    stats_views: "Vues",
    stats_views_week: "(7j)",
    my_listings: "Mes annonces",
    no_listings: "Vous n'avez pas encore d'annonce.",
    create_first: "Créer ma première annonce",
    boost: "Booster",
    edit: "Modifier",
    delete: "Supprimer",
    boosted_label: "Boostée",
    confirm_delete_title: "Supprimer cette annonce ?",
    confirm_delete_desc: "Cette action est définitive. L'annonce sera retirée du site.",
    cancel: "Annuler",
    become_pro_title: "Passez en Pro vérifié",
    become_pro_desc: "Badge vérifié, annonces illimitées et boost mensuel inclus.",
    become_pro_btn: "Devenir Pro",
    recommendation_low_views: "Peu de vues — un boost ferait décoller cette annonce",
    recommendation_low_conversion: "Beaucoup de vues mais peu de contacts — boostez ou améliorez les photos",
    views_label: "Vues",
    messages_label: "Contacts",
    conversion_label: "Conv.",
  },
  favorites: {
    overline: "Favoris",
    title: "Mes biens sauvegardés",
    empty: "Vous n'avez pas encore de favoris.",
  },
  messages: {
    overline: "Messagerie",
    title: "Mes conversations",
    empty: "Aucune conversation pour le moment.",
    select_thread: "Sélectionnez une conversation à gauche",
    with: "Avec",
    reply_placeholder: "Votre réponse...",
  },
  language: {
    fr: "Français",
    ar: "العربية",
    en: "English",
  },
};
